export function AccessibilityEN() {
  return (
    <article>
      <h1>Accessibility</h1>

      <h2>Our goal for universal design</h2>
      <p>
        We want our cloud storage service with website, web client, mobile and
        desktop apps to be accessible and easy to use for everyone.
      </p>
      <ul>
        <li>
          Minimum WCAG 2.1 level AA for all new deliverables; we work long-term
          towards level AAA where it is practically possible.
        </li>
        <li>
          Ongoing follow-up of WCAG requirements throughout the design,
          development and testing process.
        </li>
        <li>
          Third-party solutions (e.g. Microsoft Office Online editing) are
          checked to ensure that they meet Norwegian requirements for universal
          design.
        </li>
      </ul>

      <h2>How accessible are our services?</h2>
      <p>
        We still have parts of the solution that are not fully compliant with
        WCAG 2.1, but we are actively working to close the gap.
      </p>
      <ul>
        <li>
          2023 – 2024: We built a new design system; all new interface
          components are developed with WCAG 2.1 level AA as a minimum
          requirement.
        </li>
        <li>
          2025 – 2026: Step-by-step rollout of the design system in the web
          client as well as the mobile and desktop apps. Every service that is
          launched in a "new guise" is quality assured against WCAG 2.1 before
          publication.
        </li>
      </ul>

      <h2>Known availability anomalies and planned solutions</h2>

      <ul>
        <li>
          All non-text content should have machine-readable text alternatives
          (A) - Cleaned up in connection with redesign Q4 2025
        </li>
        <li>
          Some subpages in the admin interface are missing descriptive titles
          (A) - Implemented together with new header component Q1 2026
        </li>
        <li>
          All functionality must be accessible via keyboard (missing in the
          desktop apps)) (A) - Keyboard actions are added continuously - start
          Q3 2025
        </li>
        <li>
          Sequential focus order missing in some desktop dialogs (A) Implemented
          by Q1 2026
        </li>
        <li>
          «Jump to main content» missing in mobile web (A) - Implemented Q3 2025
        </li>
        <li>
          Screen reader support (JAWS, NVDA, VoiceOver) missing from desktop app
          (A) - To be implemented by Q2 2026
        </li>
        <li>
          Inconsistent use of UI components across pages (AA) - Investigated by
          Q4 2025
        </li>
        <li>
          Not all drag and drop operations have full keyboard option (AA) -
          Investigated by Q4 2025
        </li>
        <li>
          Error messages do not always provide adequate guidance (AA) - To be
          improved by the end of Q4 2025
        </li>
        <li>
          400% zoom at 1280 px width can provide horizontal scrolling in some
          file galleries on the web (AA) - To be optimized Q4 2025
        </li>
        <li>
          Text in legacy desktop dialogs does not always scale correctly at 200%
          (AA) - New desktop version by Q1 2026
        </li>
        <li>
          All UI components should display visible focus when receiving keyboard
          focus (AAA) (lacking in the desktop apps - Planned to be investigated
          by Q4 2025
        </li>
        <li>
          Provide mechanisms to identify pronunciation of words (AAA) - Planned
          to be investigated by Q2 2026
        </li>
        <li>
          Fill in previous information automatically or make it available for
          selection (AAA) - Planned investigated by Q4 2025
        </li>
      </ul>

      <h2>How do we work with universal design?</h2>
      <ul>
        <li>
          Continuous improvement of routines to ensure that new products and
          services are universally designed
        </li>
        <li>
          All new components are tested against WCAG 2.1 level AA before they
          become part of the design system.
        </li>
        <li>Clear and distinct use of language in all services we offer</li>
        <li>Regular review of existing solutions</li>
        <li>
          Continuous improvement of routines to ensure that new products and
          services are universally designed
        </li>
        <li>
          When we discover problems (via internal tests, support or partners)
          they are logged in our system and included in future development
        </li>
      </ul>

      <h2>Help us get better</h2>

      <p>
        Do you experience obstacles, or do you find the language difficult?
        Please let us know. All feedback helps us become more accessible!
      </p>

      <ul>
        <li>E-mail: support@jottacloud.com</li>
        <li>
          Contact our customer center on (+ 47) 21 04 29 00 or use the chat in
          the app/on the web
        </li>
      </ul>
    </article>
  )
}
